import './TeamMember.css'

const TeamMember = ({ name, position, description, image , click}) => {
    return (
        <>
            <div className={"col-md-4 col-lg-4 col-sm-12 col-xs-12 slide"}>
                <div className="team-members" onClick={click}>
                    <img src={image} alt={name} className="team-member-image" />
                    <div className={"team-det-container"}>
                        <h3>{name}</h3>
                        {position.map(pos => (
                            <h4>{pos}</h4>
                        ))}
                        <div className={"team-description-container"}>
                            <p className={"team-descriptions"}>{description}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TeamMember;
